(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var texts = bar.querySelectorAll('.announcement__text');
    if (texts.length <= 1) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % texts.length;
      texts.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === i);
      });
    }, 4500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-feature"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('mouseover', function (e) {
    var t = e.target.closest && e.target.closest('[data-brand-trigger]');
    if (!t) return;
    var root = t.closest('[data-brand-feature]');
    if (!root) return;
    var idx = t.getAttribute('data-brand-trigger');
    root.querySelectorAll('[data-brand-trigger]').forEach(function (x) {
      x.classList.toggle('is-active', x === t);
    });
    root.querySelectorAll('[data-brand-pane]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-brand-pane') === idx);
    });
  });

  document.addEventListener('mousemove', function (e) {
    var stage = e.target.closest && e.target.closest('[data-brand-feature] .bf__stage');
    document.querySelectorAll('[data-brand-cta]').forEach(function (cta) {
      var owner = cta.closest('.bf__stage');
      if (stage && owner === stage) {
        var r = stage.getBoundingClientRect();
        cta.style.transform = 'translate3d(' + (e.clientX - r.left) + 'px,' + (e.clientY - r.top) + 'px,0) translate(-50%, -50%)';
        cta.classList.add('is-visible');
      } else {
        cta.classList.remove('is-visible');
      }
    });
  });

  document.addEventListener('click', function (e) {
    var stage = e.target.closest && e.target.closest('[data-brand-feature] .bf__stage');
    if (!stage) return;
    if (e.target.closest('a')) return;
    var active = stage.querySelector('.bf__pane.is-active');
    var url = active && active.getAttribute('data-link');
    if (url) window.location.href = url;
  });

  /* ブランド名クリック = ホバーと同じくパネル切替のみ(ページ遷移しない) */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-brand-trigger]');
    if (!t) return;
    e.preventDefault();
    var root = t.closest('[data-brand-feature]');
    if (!root) return;
    var idx = parseInt(t.getAttribute('data-brand-trigger'), 10) || 0;
    root.querySelectorAll('[data-brand-trigger]').forEach(function (x) {
      x.classList.toggle('is-active', x === t);
    });
    root.querySelectorAll('[data-brand-pane]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-brand-pane') === String(idx));
    });
    if (window.innerWidth <= 1100) {
      var stage = root.querySelector('.bf__stage');
      if (stage) stage.scrollTo({ left: stage.clientWidth * idx, behavior: 'smooth' });
    }
  });

  document.querySelectorAll('[data-brand-feature] .bf__stage').forEach(function (stage) {
    var root = stage.closest('[data-brand-feature]');
    var ticking = false;
    stage.addEventListener('scroll', function () {
      if (window.innerWidth > 1100 || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var idx = String(Math.round(stage.scrollLeft / stage.clientWidth));
        root.querySelectorAll('[data-brand-trigger]').forEach(function (l) {
          l.classList.toggle('is-active', l.getAttribute('data-brand-trigger') === idx);
        });
        root.querySelectorAll('[data-brand-pane]').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-brand-pane') === idx);
        });
        var activeTab = root.querySelector('[data-brand-trigger].is-active');
        if (activeTab && activeTab.scrollIntoView) {
          activeTab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bh-slider]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bh-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bh-dot]'));
    if (slides.length < 2) return;
    var current = 0;
    var go = function (idx) {
      current = (idx + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    };
    root.querySelectorAll('[data-bh-prev]').forEach(function (b) {
      b.addEventListener('click', function () { go(current - 1); });
    });
    root.querySelectorAll('[data-bh-next]').forEach(function (b) {
      b.addEventListener('click', function () { go(current + 1); });
    });
    /* スマホ: スワイプで切り替え */
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      go(dx < 0 ? current + 1 : current - 1);
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var minus = e.target.closest('[data-ct-minus]');
    var plus = e.target.closest('[data-ct-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.pd__qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    input.value = minus ? Math.max(0, v - 1) : v + 1;
    var form = input.closest('form');
    if (form) form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-sort-select]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    window.location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var body = document.querySelector('[data-cf-body]');
    if (!body || body.value) return;
    var q = new URLSearchParams(location.search);
    var name = q.get('product');
    if (!name) return;
    var url = q.get('url') || '';
    var lines = ['【お問い合わせ商品】' + name];
    if (url.indexOf('http') === 0) lines.push(url);
    lines.push('', '');
    body.value = lines.join(String.fromCharCode(10));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.__inimuHeaderNavigationBound) return;
    window.__inimuHeaderNavigationBound = true;

    var desktopQuery = window.matchMedia('(min-width: 1101px)');
    var lastDrawerTrigger = null;

    function setMenuState(item, open) {
      if (!item) return;
      var trigger = item.querySelector('[data-nav-trigger]');
      item.classList.toggle('is-open', open);
      if (open) item.classList.remove('is-escape-closed');
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeDesktopMenus(except) {
      document.querySelectorAll('[data-nav-item].is-open').forEach(function (item) {
        if (item !== except) setMenuState(item, false);
      });
    }

    function openDrawer(trigger) {
      var drawer = document.querySelector('[data-drawer]');
      if (!drawer) return;
      lastDrawerTrigger = trigger || document.querySelector('[data-drawer-open]');
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      if (lastDrawerTrigger) lastDrawerTrigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-header-drawer-open');
      var closeButton = drawer.querySelector('[data-drawer-close]');
      if (closeButton) closeButton.focus();
    }

    function closeDrawer(restoreFocus) {
      var drawer = document.querySelector('[data-drawer]');
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-header-drawer-open');
      document.querySelectorAll('[data-drawer-open]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      drawer.querySelectorAll('details[open]').forEach(function (details) {
        details.open = false;
      });
      if (restoreFocus && lastDrawerTrigger) lastDrawerTrigger.focus();
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target.closest) return;

      var openButton = target.closest('[data-drawer-open]');
      if (openButton) {
        openDrawer(openButton);
        return;
      }

      if (target.closest('[data-drawer-close]')) {
        closeDrawer(true);
        return;
      }

      var navTrigger = target.closest('[data-nav-trigger]');
      if (navTrigger && desktopQuery.matches) {
        var item = navTrigger.closest('[data-nav-item]');
        var href = navTrigger.getAttribute('href') || '';
        var placeholderLink = href === '#' || href.slice(-1) === '#';
        var touchLike = window.matchMedia('(hover: none)').matches;

        if (placeholderLink || touchLike) {
          event.preventDefault();
          var willOpen = !item.classList.contains('is-open');
          closeDesktopMenus(item);
          setMenuState(item, willOpen);
        }
        return;
      }

      if (!target.closest('[data-nav-item]')) closeDesktopMenus();
    });

    document.addEventListener('pointerover', function (event) {
      if (!desktopQuery.matches || !event.target.closest) return;
      var item = event.target.closest('[data-nav-item].has-children');
      if (!item || item.contains(event.relatedTarget)) return;
      closeDesktopMenus(item);
      setMenuState(item, true);
    });

    document.addEventListener('pointerout', function (event) {
      if (!desktopQuery.matches || !event.target.closest) return;
      var item = event.target.closest('[data-nav-item].has-children');
      if (!item || item.contains(event.relatedTarget)) return;
      setMenuState(item, false);
    });

    document.addEventListener('focusin', function (event) {
      if (!desktopQuery.matches || !event.target.closest) return;
      var item = event.target.closest('[data-nav-item].has-children');
      if (!item) return;
      closeDesktopMenus(item);
      setMenuState(item, true);
    });

    document.addEventListener('focusout', function (event) {
      if (!desktopQuery.matches || !event.target.closest) return;
      var item = event.target.closest('[data-nav-item].has-children');
      if (!item) return;
      window.setTimeout(function () {
        if (!item.contains(document.activeElement)) {
          item.classList.remove('is-escape-closed');
          setMenuState(item, false);
        }
      }, 0);
    });

    document.addEventListener('toggle', function (event) {
      var details = event.target;
      if (!details.matches || !details.matches('[data-mobile-accordion]') || !details.open) return;
      Array.prototype.forEach.call(details.parentElement.children, function (sibling) {
        if (sibling !== details && sibling.matches && sibling.matches('[data-mobile-accordion]')) {
          sibling.open = false;
        }
      });
    }, true);

    document.addEventListener('keydown', function (event) {
      var drawer = document.querySelector('[data-drawer]');

      if (event.key === 'Escape') {
        if (drawer && !drawer.hidden) {
          closeDrawer(true);
          return;
        }

        var openItem = document.querySelector('[data-nav-item].is-open');
        if (openItem) {
          var trigger = openItem.querySelector('[data-nav-trigger]');
          if (trigger) trigger.focus();
          setMenuState(openItem, false);
          openItem.classList.add('is-escape-closed');
        }
        return;
      }

      if (event.key === 'Tab' && drawer && !drawer.hidden) {
        var focusable = drawer.querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    function handleViewportChange() {
      closeDesktopMenus();
      if (desktopQuery.matches) closeDrawer(false);
    }

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', handleViewportChange);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(handleViewportChange);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function root() { return document.querySelector('.pd'); }

    function setMainImage(url) {
      var main = document.querySelector('.pd__main img');
      if (!main || !url) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = url;
    }

    function getVariants() {
      var el = document.querySelector('[data-pd-variants]');
      if (!el) return [];
      try { return JSON.parse(el.textContent); } catch (e) { return []; }
    }

    function selectedOptions() {
      var opts = [];
      document.querySelectorAll('.pd__option').forEach(function (fs, i) {
        var radio = fs.querySelector('input[type="radio"]:checked');
        var select = fs.querySelector('select');
        opts[i] = radio ? radio.value : (select ? select.value : null);
      });
      return opts;
    }

    function yen(cents) {
      return (cents / 100).toLocaleString('ja-JP') + '円（税込）';
    }

    function syncPills() {
      document.querySelectorAll('.pd__pill').forEach(function (label) {
        var input = label.querySelector('input[type="radio"]');
        label.classList.toggle('is-active', !!(input && input.checked));
      });
    }

    /* 各選択肢について、他の選択と組み合わせて在庫のあるバリエーションが無ければ「在庫なし」表示 */
    function markAvailability(variants, opts) {
      document.querySelectorAll('.pd__option').forEach(function (fs, i) {
        function ok(value) {
          return variants.some(function (v) {
            if (!v.available) return false;
            return v.options.every(function (o, j) {
              if (j === i) return o === value;
              return opts[j] == null || o === opts[j];
            });
          });
        }
        fs.querySelectorAll('.pd__pill').forEach(function (label) {
          var input = label.querySelector('input');
          if (input) label.classList.toggle('is-soldout', !ok(input.value));
        });
        fs.querySelectorAll('select option').forEach(function (opt) {
          var base = opt.getAttribute('data-label') || opt.textContent.trim();
          opt.setAttribute('data-label', base);
          opt.textContent = ok(opt.value) ? base : base + '（在庫なし）';
        });
      });
    }

    function update() {
      if (!root()) return;
      syncPills();
      var opts = selectedOptions();
      if (!opts.length) return;
      var variants = getVariants();
      markAvailability(variants, opts);
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var idInput = document.querySelector('[data-pd-id]');
      var price = document.querySelector('[data-pd-price]');
      var compare = document.querySelector('[data-pd-compare]');
      var add = document.querySelector('[data-pd-add]');
      if (!match) {
        if (add) { add.disabled = true; add.textContent = 'この組み合わせは選べません'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (price) price.textContent = yen(match.price);
      if (compare) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compare.hidden = false;
          compare.textContent = yen(match.compare_at_price);
        } else {
          compare.hidden = true;
        }
      }
      var off = document.querySelector('[data-pd-off]');
      if (off) {
        var rate = (match.compare_at_price && match.compare_at_price > match.price) ? Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price) : 0;
        off.hidden = rate === 0;
        off.textContent = rate === 0 ? '' : rate + '%OFF';
      }
      if (add) {
        add.disabled = !match.available;
        add.textContent = match.available ? 'カートに入れる' : 'SOLD OUT';
      }
      if (match.featured_image && match.featured_image.src) {
        setMainImage(match.featured_image.src);
      }
    }

    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('[data-pd-option], .pd__option select')) update();
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', update);
    } else {
      update();
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var qtyWrap = document.querySelector('[data-pd-qty]');
      if (qtyWrap) {
        var input = qtyWrap.querySelector('input');
        if (e.target.closest('[data-pd-qty-minus]')) {
          input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
        }
        if (e.target.closest('[data-pd-qty-plus]')) {
          input.value = parseInt(input.value || '1', 10) + 1;
        }
      }
      var thumb = e.target.closest('[data-pd-thumb]');
      if (thumb) {
        setMainImage(thumb.getAttribute('data-pd-thumb'));
        document.querySelectorAll('.pd__thumb').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      }
    });

    /* ギャラリー自動スライド(ホバーで一時停止) */
    (function () {
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-pd-thumb]'));
      if (thumbs.length < 2) return;
      var idx = 0;
      var timer = null;
      var gallery = document.querySelector('.pd__gallery');

      function swap(i) {
        idx = (i + thumbs.length) % thumbs.length;
        var main = document.querySelector('.pd__main img');
        if (!main) return;
        main.style.opacity = '0';
        setTimeout(function () {
          setMainImage(thumbs[idx].getAttribute('data-pd-thumb'));
          main.style.opacity = '1';
        }, 220);
        thumbs.forEach(function (t, ti) {
          t.classList.toggle('is-active', ti === idx);
        });
      }
      function play() {
        stop();
        timer = setInterval(function () { swap(idx + 1); }, 4200);
      }
      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      play();
      if (gallery) {
        gallery.addEventListener('mouseenter', stop);
        gallery.addEventListener('mouseleave', play);
      }
      document.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('[data-pd-thumb]');
        if (t) {
          idx = thumbs.indexOf(t);
          play();
        }
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();
})();
